export default __webpack_public_path__ + "static/18 - Elektromos autó töltő-c18c58eefd95165d75a2bb2798cd818e.jpg";